import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./protected";
import React from "react";
import { SidebarProvider } from "../context/sidebar";

const Layout = React.lazy(() => import("../layouts"));
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Forms = React.lazy(() => import("../pages/forms"));
const StaffPage = React.lazy(() => import("../pages/staff"));
const DecisionLetterPage = React.lazy(() => import("../pages/decisionLetter"));
const JobOpeningPage = React.lazy(() => import("../pages/jobOpenings"));
const JobOpeningCreatePage = React.lazy(() => import("../pages/jobOpenings/create"));
const JobOpeningEditPage = React.lazy(() => import("../pages/jobOpenings/edit/page"));
const CandidatePage = React.lazy(() => import("../pages/candidates"));
const QuestionBankPage = React.lazy(() => import("../pages/questionBank"));
const QuestionBankCreatePage = React.lazy(() => import("../pages/questionBank/form/page"));
const QuestionBankEditPage = React.lazy(() => import("../pages/questionBank/edit/page"));
const QuestionBankEditIndikatorPage = React.lazy(() => import("../pages/questionBank/edit/indikator/page"));
const QuestionBankEditPilihanGandaPage = React.lazy(() => import("../pages/questionBank/edit/pilihan-ganda/page"));
const QuestionBankMultipleChoiceCreatePage = React.lazy(() => import("../pages/questionBank/form/multiple-choice/page"));
const QuestionBankWeightedScaleCreatePage = React.lazy(() => import("../pages/questionBank/form/weighted-scale/page"));
const QuestionBankEditWeightedScalePage = React.lazy(() => import("../pages/questionBank/edit/weighted-scale/page"));
const ApplicationStagesPage = React.lazy(() => import("../pages/applicationStages"));
const EvaluationsPage = React.lazy(() => import("../pages/evaluations"));
const EvaluatorQueuePage = React.lazy(() => import("../pages/evaluatorQueue"));
const OnlineTestsPage = React.lazy(() => import("../pages/onlineTests"));
const RecommendationsPage = React.lazy(() => import("../pages/recommendations"));
const Login = React.lazy(() => import("../pages/login"));
const Auth = React.lazy(() => import("../pages/auth"));
const NotFound = React.lazy(() => import("../pages/404"));

const MainRouter = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute
        element={
          <SidebarProvider>
            <Layout />
          </SidebarProvider>
        }
      />
    ),
    children: [
      { index: true, element: <Dashboard />, handle: { name: "Beranda" } },
      { path: "pegawai", element: <StaffPage />, handle: { name: "Pegawai" } },
      { path: "sk", element: <DecisionLetterPage />, handle: { name: "Surat Keputusan" } },
      { path: "forms", element: <Forms />, handle: { name: "Formulir" } },
      { path: "kandidat", element: <CandidatePage />, handle: {name:"Kandidat"}},
      { path: "tahap-ujian", element: <ApplicationStagesPage />, handle: {name:"Tahap Ujian"}},
      { path: "online-test", element: <OnlineTestsPage />, handle: {name:"Online Test"}},
      { path: "evaluasi", element: <EvaluationsPage />, handle: {name:"Evaluasi"}},
      { path: "evaluator-queue", element: <EvaluatorQueuePage />, handle: {name:"Antrian Evaluator"}},
      { path: "rekomendasi", element: <RecommendationsPage />, handle: {name:"Rekomendasi"}},
      {
        path: "bank-soal",
        handle: { name: "Bank Soal" },
        children: [
          {
            index: true,
            element: <QuestionBankPage />,
            handle: { name: "Daftar" },
          },
          {
            path: "buat",
            element: <QuestionBankCreatePage />,
            handle: { name: "Buat Indikator" },
          },
          {
            path: "buat-pilihan-ganda",
            element: <QuestionBankMultipleChoiceCreatePage />,
            handle: { name: "Buat Pilihan Ganda" },
          },
          {
            path: "buat-skala-berbobot",
            element: <QuestionBankWeightedScaleCreatePage />,
            handle: { name: "Buat Skala Berbobot" },
          },
          {
            path: "edit/:id",
            element: <QuestionBankEditPage />,
            handle: { name: "Edit" },
          },
          {
            path: "edit-indikator/:id",
            element: <QuestionBankEditIndikatorPage />,
            handle: { name: "Edit Indikator" },
          },
          {
            path: "edit-pilihan-ganda/:id",
            element: <QuestionBankEditPilihanGandaPage />,
            handle: { name: "Edit Pilihan Ganda" },
          },
          {
            path: "edit-skala-berbobot/:id",
            element: <QuestionBankEditWeightedScalePage />,
            handle: { name: "Edit Skala Berbobot" },
          }
        ]
      },
      {
        path: "lowongan-kerja",
        handle: { name: "Lowongan Kerja" },
        children: [
          {
            index: true,
            element: <JobOpeningPage />,
            handle: { name: "Daftar" },
          },
          {
            path: "buat",
            element: <JobOpeningCreatePage />,
            handle: { name: "Buat" },
          },
          {
            path: "edit/:id",
            element: <JobOpeningEditPage />,
            handle: { name: "Edit" },
          }
        ]
      }
      // {
      //   path: "master",
      //   element: <></>,
      //   handle: { name: "Master" },
      //   children: [
      //     {
      //       path: "goods",
      //       element: <>barang</>,
      //       handle: { name: "Barang" },
      //       children: [
      //         {
      //           path: "forms",
      //           element: <>barang</>,
      //           handle: { name: "form" },
      //         },
      //         { path: "add", element: <>barang</>, handle: { name: "add" } },
      //       ],
      //     },
      //   ],
      // },
    ],
  },
  { path: "/login", element: <Login />, handle: { name: "Login" } },
  { path: "/auth", element: <Auth />, handle: { name:"Auth" }},
  { path: "*", element:<NotFound />, handle: { name: "NotFound"}},
]);

export default MainRouter;
